enum CargoCargoTaxiContractListingFilterType {
  CARGO_COMPANY = "CARGO_COMPANY",
  TAXI_CORPORATION = "TAXI_CORPORATION",
  ACTIVE = "ACTIVE",
}

export default CargoCargoTaxiContractListingFilterType;
